var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDashboardManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3258_50912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1922 20.73C12.9816 20.5754 12.6853 20.6206 12.5305 20.8313L12.472 20.9108C12.3174 21.1214 12.3624 21.4173 12.5728 21.5722C12.6573 21.6345 12.7557 21.6646 12.8532 21.6646C12.9983 21.6646 13.1415 21.5981 13.2343 21.4724L13.2936 21.3918C13.4483 21.181 13.4029 20.8847 13.1922 20.73Z",
    fill: "url(#paint0_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3156 25.2338L12.0981 23.0199L13.2348 21.4717C13.3896 21.261 13.3442 20.9647 13.1334 20.8099C12.9227 20.6551 12.6264 20.7005 12.4717 20.9114L11.156 22.7032C11.0469 22.8517 11.034 23.05 11.1228 23.2115L12.486 25.69V25.69C12.5723 25.8466 12.7342 25.9353 12.9013 25.9353C12.9784 25.9352 13.0567 25.9164 13.129 25.8766C13.358 25.7507 13.4416 25.4628 13.3156 25.2338Z",
    fill: "url(#paint1_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8439 22.7031L15.5336 20.9185C15.4249 20.7706 15.2408 20.6987 15.0606 20.7344C14.8805 20.7697 14.7372 20.9061 14.6927 21.0841C14.6585 21.2209 14.687 21.3656 14.7704 21.4791L15.9016 23.0198L14.6924 25.2186C14.654 25.2885 14.6338 25.3672 14.6338 25.447C14.6338 25.6631 14.7801 25.8517 14.9894 25.9055C15.0286 25.9156 15.0682 25.9205 15.1072 25.9205C15.2767 25.9205 15.4373 25.8291 15.522 25.6752L16.8771 23.2115C16.9659 23.0499 16.9529 22.8516 16.8439 22.7031Z",
    fill: "url(#paint2_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5942 15.2635C17.4385 15.1818 17.2502 15.1929 17.1054 15.2928C16.8238 15.4868 16.5625 15.6923 16.3288 15.9036C15.0548 17.0553 13.8444 16.8994 13.7969 16.8926C13.7684 16.8882 13.7394 16.8861 13.7106 16.887C13.2071 16.8999 12.2993 16.4398 11.339 15.6856C11.1921 15.5702 11.0415 15.4603 10.8911 15.3588C10.746 15.2608 10.5586 15.2509 10.4041 15.3331C10.2495 15.4153 10.1528 15.576 10.1528 15.7511V17.3751C10.1528 17.5188 10.2182 17.6545 10.3302 17.7444C10.3434 17.7551 10.3572 17.7649 10.3714 17.774L13.7282 20.017C13.7287 20.0174 13.7292 20.0178 13.7298 20.0182L13.7386 20.0241C13.8177 20.0764 13.9087 20.1028 14.0001 20.1028C14.077 20.1028 14.1539 20.0842 14.2242 20.0466C14.239 20.0387 14.2532 20.03 14.2669 20.0207C14.2685 20.0196 14.27 20.0186 14.2717 20.0175C14.2735 20.0163 14.2754 20.015 14.2773 20.0138L17.6261 17.776C17.6396 17.7675 17.6527 17.7583 17.6653 17.7484C17.7802 17.6588 17.8474 17.5211 17.8474 17.3753V15.6827C17.8474 15.5067 17.7499 15.3454 17.5942 15.2635ZM16.9005 17.1219L14.0001 19.0601L11.0996 17.1219V16.6913C11.8059 17.2046 12.8448 17.8341 13.6916 17.834C13.6934 17.834 13.6953 17.834 13.6971 17.834C13.9815 17.8655 15.4314 17.951 16.9006 16.6621V17.1219H16.9005Z",
    fill: "url(#paint3_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.467 19.5518C14.4358 19.3641 14.2951 19.2133 14.1099 19.1691C13.9246 19.1252 13.7311 19.196 13.6185 19.3495L12.5303 20.8315C12.3756 21.0423 12.421 21.3386 12.6318 21.4933C12.7162 21.5553 12.8143 21.5852 12.9116 21.5852C13.0571 21.5852 13.2008 21.5182 13.2936 21.3918L14.376 19.9175C14.4376 19.837 14.4735 19.7369 14.4735 19.6298C14.4734 19.6037 14.4713 19.5775 14.467 19.5518Z",
    fill: "url(#paint4_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2122 4.29004C21.2028 4.21588 20.9811 2.6154 19.4745 1.98403C19.5183 1.70293 19.5137 1.34167 19.3352 0.990189C19.0954 0.517798 18.622 0.209961 17.9283 0.0751016C17.8986 0.0693047 17.8684 0.0664062 17.838 0.0664062H11.4841C8.90401 0.0664062 6.80493 2.16543 6.80493 4.74559V7.23885C6.80493 7.88843 7.02636 8.52188 7.42832 9.02238C7.6276 9.27055 7.87304 9.70395 7.91006 10.3592C7.9245 10.615 8.13865 10.8127 8.39607 10.8056C8.65222 10.7984 8.8561 10.5886 8.8561 10.3324V7.08179C9.17755 5.75239 10.2746 5.49366 10.4633 5.45871H12.5185C12.7603 5.45871 12.998 5.4218 13.2253 5.34896C13.6161 5.22361 14.236 4.99294 14.6874 4.82149C14.9894 4.7067 15.3238 4.70249 15.6288 4.80968L17.8291 5.58209C18.9291 5.98787 19.1254 6.95355 19.1497 7.10525V11.0065C19.1497 11.2543 19.3408 11.4599 19.5878 11.4783C19.5999 11.4792 19.6117 11.4797 19.6235 11.4797C19.8557 11.4796 20.0562 11.3095 20.0913 11.0763C20.0932 11.0641 20.2822 9.84313 20.8917 8.86553C21.1038 8.52521 21.216 8.1372 21.216 7.74345V4.34981C21.216 4.32985 21.2147 4.30989 21.2122 4.29004ZM20.2691 7.74323C20.2691 7.95471 20.2095 8.16449 20.0965 8.35103V7.07287C20.0965 7.05576 20.0956 7.03875 20.0937 7.02174C20.0863 6.953 19.8906 5.33064 18.1524 4.6921C18.1503 4.69134 18.1481 4.69057 18.146 4.68981L15.9424 3.91619C15.6939 3.82897 15.434 3.78544 15.1742 3.78544C14.8949 3.78544 14.6157 3.8358 14.3512 3.93643C13.7192 4.17651 13.2298 4.3532 12.9361 4.44738C12.8025 4.4902 12.662 4.51196 12.5185 4.51196H10.425C10.4047 4.51196 10.3843 4.51327 10.3642 4.51584C10.284 4.52624 8.39585 4.79475 7.92067 6.92456C7.91312 6.95841 7.90929 6.99297 7.90929 7.02765V8.00196C7.80621 7.76374 7.75163 7.50354 7.75163 7.2389V4.7457C7.75163 2.68769 9.426 1.01332 11.4839 1.01332H17.7903C18.0513 1.06894 18.3686 1.18307 18.489 1.41528C18.6364 1.69949 18.4685 2.09083 18.4683 2.09116C18.4078 2.21995 18.4085 2.36908 18.47 2.49733C18.5316 2.62557 18.6476 2.7193 18.786 2.75261C19.9912 3.04272 20.237 4.19866 20.2691 4.38563L20.2691 7.74323Z",
    fill: "url(#paint5_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0939 7.02167C20.0864 6.95293 19.8908 5.33057 18.1526 4.69203C18.1504 4.69127 18.1483 4.6905 18.1462 4.68974L15.9425 3.91613C15.4268 3.73511 14.8618 3.74233 14.3513 3.93625C13.7193 4.17633 13.2299 4.35303 12.9362 4.44725C12.8026 4.49007 12.6621 4.51178 12.5186 4.51178H10.4251C10.4048 4.51178 10.3845 4.5131 10.3643 4.51567C10.2842 4.52606 8.39598 4.79457 7.9208 6.92438C7.91325 6.95823 7.90942 6.9928 7.90942 7.02747V11.0971C7.90942 11.1006 7.90948 11.1041 7.90953 11.1076C7.91265 11.249 8.01267 14.5875 10.3194 16.1143L10.3313 16.1227C10.3412 16.1297 10.3511 16.1367 10.3615 16.1437C10.493 16.2325 10.625 16.3289 10.7542 16.4303C11.4262 16.958 12.6926 17.8341 13.6917 17.8341C13.6935 17.8341 13.6953 17.8341 13.6972 17.8341C13.7514 17.8401 13.8483 17.8481 13.9796 17.8481C14.5458 17.8481 15.7538 17.6997 16.9637 16.6059C17.1667 16.4225 17.395 16.243 17.6426 16.0725L17.6779 16.0477C17.6895 16.0395 17.701 16.0313 17.7129 16.0234C18.4824 15.5066 19.815 14.1731 20.0948 11.0485C20.0961 11.0345 20.0967 11.0204 20.0967 11.0063V7.0728C20.0967 7.05574 20.0957 7.03873 20.0939 7.02167ZM19.1498 10.9849C18.8918 13.8047 17.6904 14.8978 17.185 15.2373C17.1671 15.2494 17.1493 15.2618 17.1316 15.2743L17.1054 15.2928C16.8238 15.4868 16.5625 15.6923 16.3287 15.9035C15.0595 17.051 13.853 16.9005 13.7939 16.8922C13.7664 16.8881 13.7385 16.8863 13.7106 16.8871C13.2071 16.9 12.2993 16.4399 11.3389 15.6857C11.192 15.5703 11.0414 15.4604 10.8913 15.359L10.8796 15.3508C10.8682 15.3427 10.8569 15.3347 10.8436 15.3258C8.98212 14.0938 8.86033 11.2106 8.85623 11.0903V7.08166C9.17883 5.7474 10.2827 5.49162 10.4626 5.45859H12.5187C12.7604 5.45859 12.9982 5.42168 13.2254 5.34883C13.6162 5.22349 14.2362 4.99282 14.6876 4.82137C14.9896 4.70658 15.3239 4.70237 15.6289 4.80956L17.8292 5.58197C18.9292 5.98775 19.1255 6.95342 19.1499 7.10512V10.9849H19.1498Z",
    fill: "url(#paint6_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4235 19.4182C14.3497 19.2706 14.2044 19.1721 14.0401 19.1581C13.876 19.1446 13.716 19.2167 13.6184 19.3497L12.4844 20.8942C12.3298 21.1048 12.375 21.4009 12.5855 21.5557C12.6699 21.6179 12.7682 21.6479 12.8656 21.6479C13.0108 21.6479 13.1542 21.5812 13.247 21.4553L14.3811 19.9165C14.4411 19.8351 14.4735 19.7311 14.4735 19.63C14.4735 19.5566 14.4563 19.4839 14.4235 19.4182Z",
    fill: "url(#paint7_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4537 27.0403C14.2759 26.8543 13.9821 26.8444 13.7922 27.0181L13.684 27.1171C13.5219 27.2653 13.483 27.5055 13.5901 27.6972L13.5935 27.7032C13.6658 27.8327 13.7947 27.9209 13.9417 27.9413C13.9634 27.9443 13.9852 27.9457 14.0068 27.9457C14.1315 27.9457 14.2522 27.8965 14.3416 27.8071L14.4464 27.7021C14.6284 27.5202 14.6316 27.2262 14.4537 27.0403Z",
    fill: "url(#paint8_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3162 27.1171L14.2079 27.0181C14.0181 26.8444 13.7242 26.8543 13.5463 27.0402C13.3684 27.2263 13.3717 27.5203 13.5537 27.7022L13.6587 27.8072C13.7481 27.8966 13.8688 27.9458 13.9934 27.9458C14.0157 27.9458 14.038 27.9443 14.0604 27.9411C14.2078 27.92 14.3368 27.8307 14.4085 27.7001L14.4118 27.6941C14.5167 27.5027 14.4772 27.2644 14.3162 27.1171Z",
    fill: "url(#paint9_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3242 27.1245L14.3236 27.124C14.2504 27.0556 14.1559 27.0106 14.0517 26.9991C13.9122 26.9839 13.7763 27.0312 13.6775 27.1232L13.6761 27.1245C13.5804 27.2118 13.5246 27.3346 13.5218 27.4641C13.519 27.5937 13.5695 27.7187 13.6613 27.81L13.6663 27.815C13.7586 27.9068 13.8793 27.9527 14.0001 27.9527C14.1213 27.9527 14.2424 27.9064 14.3348 27.8141L14.3397 27.8091C14.4312 27.7176 14.4813 27.5928 14.4783 27.4635C14.4754 27.3342 14.4197 27.2117 14.3242 27.1245Z",
    fill: "url(#paint10_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1537 19.1715C13.9576 19.1087 13.7425 19.1815 13.6231 19.3494C13.4895 19.5374 13.5116 19.7936 13.6743 19.9571C13.7658 20.0491 13.8873 20.0962 14.0098 20.0962C14.1049 20.0962 14.2005 20.0678 14.2829 20.0097C14.4089 19.9211 14.4839 19.7767 14.4839 19.6226V19.6214C14.4839 19.4154 14.3499 19.2341 14.1537 19.1715Z",
    fill: "url(#paint11_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3847 19.3454L14.3807 19.3399C14.2592 19.1755 14.0459 19.1078 13.8518 19.1718C13.6578 19.2357 13.5266 19.417 13.5266 19.6213V19.6294C13.5266 19.8037 13.6244 19.9626 13.778 20.0451C13.8476 20.0824 13.9244 20.1009 14.001 20.1009C14.0935 20.1009 14.1859 20.0741 14.2653 20.0214C14.3735 19.9498 14.4476 19.8368 14.4702 19.709C14.4928 19.5813 14.4619 19.4497 14.3847 19.3454Z",
    fill: "url(#paint12_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6317 17.8583C19.5826 17.7287 19.4792 17.6271 19.3487 17.5804L17.5336 16.9297C17.5189 16.9244 17.5036 16.9197 17.4884 16.916C17.3588 16.8836 17.2216 16.9074 17.1106 16.9817L13.7474 19.229C13.7465 19.2296 13.7455 19.2302 13.7446 19.2308L14.0087 19.6235L13.7387 19.2348C13.64 19.3001 13.5694 19.4001 13.5407 19.5148C13.525 19.5778 13.5224 19.6436 13.5331 19.7077C13.5453 19.7808 13.5745 19.8502 13.6184 19.9101L16.0807 23.2636C16.1702 23.3855 16.3122 23.4568 16.4622 23.4568C16.4725 23.4568 16.4829 23.4564 16.4932 23.4557C16.6545 23.4451 16.7992 23.3531 16.8771 23.2114L19.6037 18.2541C19.6705 18.1326 19.6808 17.9879 19.6317 17.8583ZM16.4049 22.1053L14.6743 19.7483L17.4384 17.9013L18.5066 18.2843L16.4049 22.1053Z",
    fill: "url(#paint13_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4664 19.5479C14.4441 19.4208 14.371 19.3083 14.2638 19.2364L10.8894 16.9816C10.782 16.9097 10.6496 16.8851 10.5234 16.9131C10.5041 16.9174 10.485 16.923 10.4664 16.9297L8.65126 17.5803C8.52077 17.6271 8.41736 17.7287 8.3683 17.8583C8.31925 17.988 8.32942 18.1326 8.39625 18.2541L11.1228 23.2114C11.2007 23.353 11.3454 23.4451 11.5067 23.4557C11.517 23.4563 11.5273 23.4567 11.5376 23.4567C11.6877 23.4567 11.8296 23.3854 11.9192 23.2634L13.2349 21.4715C13.2359 21.4701 13.237 21.4687 13.238 21.4672L14.3816 19.9096C14.4579 19.8056 14.4886 19.675 14.4664 19.5479ZM12.4718 20.911C12.4706 20.9125 12.4695 20.914 12.4684 20.9156L11.5949 22.1053L9.49323 18.2842L10.5615 17.9013L13.3255 19.7483L12.4718 20.911Z",
    fill: "url(#paint14_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9765 25.94L27.3658 22.2523C27.1733 21.0901 26.3657 20.1191 25.2579 19.7185L19.3498 17.581C19.1676 17.5151 18.964 17.5668 18.8353 17.7112C18.7066 17.8558 18.6787 18.0641 18.7651 18.2375L19.9987 20.7112L18.7883 20.7298C18.6239 20.7324 18.4726 20.8199 18.3887 20.9612C18.3047 21.1025 18.2999 21.2772 18.3762 21.4228L18.8726 22.3707L13.792 27.0185C13.7868 27.0232 13.7817 27.028 13.7767 27.033L13.6718 27.1379C13.5233 27.2866 13.4904 27.5154 13.5913 27.6998L13.595 27.7065C13.6781 27.8583 13.8373 27.9527 14.0104 27.9527H26.2697C26.779 27.9527 27.26 27.73 27.5892 27.3416C27.9186 26.9532 28.0597 26.4423 27.9765 25.94ZM26.8673 26.7292C26.7181 26.9051 26.5003 27.006 26.2698 27.006H15.2083L19.7808 22.8232C19.9394 22.6782 19.9804 22.4447 19.8807 22.2543L19.5718 21.6646L20.7654 21.6462C20.9281 21.6438 21.078 21.5579 21.1626 21.4189C21.2471 21.2798 21.2544 21.1072 21.1818 20.9616L20.1407 18.8739L24.9361 20.6087C25.7222 20.8931 26.2954 21.5821 26.4319 22.4069L27.0426 26.0946V26.0947C27.0803 26.3221 27.0164 26.5534 26.8673 26.7292Z",
    fill: "url(#paint15_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3281 27.1284L14.3226 27.1234C14.1353 26.9538 13.8475 26.9613 13.6692 27.1406L13.6643 27.1455C13.5295 27.2812 13.4895 27.4846 13.5629 27.6611C13.6363 27.8377 13.8088 27.9527 14 27.9527H14.0104C14.2061 27.9527 14.3817 27.8322 14.4521 27.6496C14.5226 27.4669 14.4733 27.2597 14.3281 27.1284Z",
    fill: "url(#paint16_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3132 27.1147C14.2057 27.0179 14.06 26.9756 13.9172 26.9999C13.7747 27.024 13.651 27.1121 13.5814 27.2389L13.5781 27.2448C13.4783 27.4268 13.5087 27.6525 13.653 27.8017L13.6547 27.8035C13.7474 27.8993 13.871 27.9477 13.9949 27.9477C14.109 27.9477 14.2233 27.9067 14.3139 27.8239L14.3189 27.8194C14.3618 27.7803 14.3973 27.7334 14.4233 27.6813C14.5186 27.4908 14.4715 27.2571 14.3132 27.1147Z",
    fill: "url(#paint17_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3337 27.1435L14.3318 27.1414C14.3305 27.1402 14.3292 27.1389 14.328 27.1377L14.223 27.0328C14.2181 27.0278 14.213 27.0229 14.2079 27.0183L9.12721 22.3706L9.62372 21.4227C9.70001 21.2771 9.69525 21.1023 9.6113 20.961C9.5273 20.8198 9.37604 20.7322 9.2117 20.7297L8.00119 20.711L9.23472 18.2373C9.32113 18.064 9.29324 17.8556 9.16456 17.7111C9.03588 17.5665 8.832 17.5148 8.65006 17.5808L2.74199 19.7183C1.63424 20.1189 0.826505 21.0899 0.634059 22.2521L0.0233626 25.9399C-0.0598173 26.4423 0.0813862 26.9531 0.410715 27.3414C0.740098 27.7298 1.22108 27.9525 1.73022 27.9525H14C14.1918 27.9525 14.3645 27.8369 14.4376 27.6597C14.5107 27.4825 14.4697 27.2786 14.3337 27.1435ZM1.73027 27.0058C1.49971 27.0058 1.28194 26.9049 1.13286 26.729C0.983786 26.5532 0.919911 26.322 0.957536 26.0945L1.56823 22.4067C1.70479 21.5819 2.27797 20.8929 3.0641 20.6085L7.85939 18.8737L6.81835 20.9613C6.74573 21.1069 6.75295 21.2795 6.83755 21.4186C6.92204 21.5576 7.07205 21.6435 7.23474 21.6459L8.42836 21.6644L8.11948 22.2541C8.01978 22.4444 8.0608 22.678 8.21929 22.823L12.7918 27.0058H1.73027Z",
    fill: "url(#paint18_linear_3258_50912)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6112 21.3135C15.6454 21.1768 15.6169 21.032 15.5335 20.9184L14.3815 19.3495C14.2604 19.1845 14.0469 19.119 13.8526 19.1827C13.7476 19.2171 13.6611 19.2866 13.6036 19.3753L12.4726 20.9099C12.4564 20.9318 12.442 20.9553 12.4299 20.9797C12.3524 21.1348 12.3658 21.3197 12.4647 21.462L12.9464 22.1536L12.4333 25.3877C12.4168 25.4915 12.4354 25.5978 12.4861 25.69L13.5852 27.6883C13.6684 27.8396 13.8274 27.9336 14 27.9336C14.1726 27.9336 14.3316 27.8396 14.4148 27.6883L15.5221 25.6751C15.5605 25.6053 15.5807 25.5268 15.5807 25.447V25.4468C15.5807 25.4219 15.5787 25.3971 15.5748 25.3726L15.0641 22.1536L15.5405 21.4696C15.5732 21.4223 15.5974 21.3693 15.6112 21.3135ZM14 26.4779L13.3938 25.3758L13.9113 22.1137C13.9305 21.9929 13.9022 21.8694 13.8323 21.769L13.4356 21.1993L14.0014 20.4316L14.5701 21.2062L14.1782 21.769C14.1083 21.8693 14.0799 21.9929 14.0991 22.1137L14.6143 25.3609L14 26.4779Z",
    fill: "url(#paint19_linear_3258_50912)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3258_50912",
    x1: 12.8828,
    y1: 20.3617,
    x2: 12.8828,
    y2: 21.8464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3258_50912",
    x1: 12.2192,
    y1: 19.3129,
    x2: 12.2192,
    y2: 26.8593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3258_50912",
    x1: 15.7847,
    y1: 19.3261,
    x2: 15.7847,
    y2: 26.8406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3258_50912",
    x1: 14.0001,
    y1: 13.8912,
    x2: 14.0001,
    y2: 20.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3258_50912",
    x1: 13.456,
    y1: 18.5021,
    x2: 13.456,
    y2: 22.0154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3258_50912",
    x1: 14.0105,
    y1: -3.00752,
    x2: 14.0105,
    y2: 13.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3258_50912",
    x1: 14.0031,
    y1: -0.00208675,
    x2: 14.0031,
    y2: 20.3387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3258_50912",
    x1: 13.433,
    y1: 18.4855,
    x2: 13.433,
    y2: 22.0891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3258_50912",
    x1: 14.0575,
    y1: 26.6108,
    x2: 14.0575,
    y2: 28.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3258_50912",
    x1: 13.9426,
    y1: 26.6108,
    x2: 13.9426,
    y2: 28.1321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3258_50912",
    x1: 14.0001,
    y1: 26.7388,
    x2: 14.0001,
    y2: 28.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3258_50912",
    x1: 14.0099,
    y1: 18.8941,
    x2: 14.0099,
    y2: 20.2639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3258_50912",
    x1: 14.002,
    y1: 18.8913,
    x2: 14.002,
    y2: 20.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3258_50912",
    x1: 16.5945,
    y1: 15.1364,
    x2: 16.5945,
    y2: 24.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3258_50912",
    x1: 11.4055,
    y1: 15.1365,
    x2: 11.4055,
    y2: 24.6176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3258_50912",
    x1: 20.7665,
    y1: 14.7517,
    x2: 20.7665,
    y2: 29.7946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3258_50912",
    x1: 14.0052,
    y1: 26.7446,
    x2: 14.0052,
    y2: 28.1213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3258_50912",
    x1: 13.9961,
    y1: 26.7361,
    x2: 13.9961,
    y2: 28.1167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3258_50912",
    x1: 7.23669,
    y1: 14.7515,
    x2: 7.23669,
    y2: 29.7945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3258_50912",
    x1: 14.0026,
    y1: 16.7954,
    x2: 14.0026,
    y2: 29.4877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3258_50912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.00952148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardManager);
export default __webpack_public_path__ + "static/media/icon-dashboard-manager.5a992cfa0ce77336e679eb6f850d17d6.svg";
export { ForwardRef as ReactComponent };